import moment from 'moment';
import { Brand } from '../types/brand';
import { CameraState, CurrentState, OperationalStateStatus } from '../types/currentState';
import { Device, DeviceGpsType } from '../types/device';
import { SubBrand } from '../types/subBrand';
import { VersionCore } from '../types/version';

export const getSatellitesImage = (satellitesCount: number = 0) => {
  let img = '';
  if (satellitesCount < 8) {
    img = 'gps_1';
  } else if (satellitesCount >= 8 && satellitesCount <= 11) {
    img = 'gps_2';
  } else if (satellitesCount >= 12 && satellitesCount <= 15) {
    img = 'gps_3';
  } else if (satellitesCount >= 15) {
    img = 'gps_full';
  }

  return `/img/icons/satellites/${img}.svg`;
};

export const getSignalImage = (signal: number) => {
  let img = 'gsm_no';
  if (signal <= -100 || !signal) {
    img = 'gsm_1';
  } else if (signal <= -86 && signal >= -100) {
    img = 'gsm_2';
  } else if (signal <= -71 && signal >= -85) {
    img = 'gsm_3';
  } else if (signal >= -70) {
    img = 'gsm_full';
  }

  return `/img/icons/signal/${img}.svg`;
};

export function isBrand(brand: any): brand is Brand {
  return !!(brand as Brand)?.name;
}

export function isSubBrand(subBrand: any): subBrand is SubBrand {
  return !!(subBrand as SubBrand)?.name;
}

export function isVersion(version: any): version is VersionCore {
  return !!(version as VersionCore)?.name;
}

export function isDevice(device: Device | string | undefined): device is Device {
  return typeof device === 'object' && device !== null && '_id' in device && 'ident' in device;
}

export const deviceIsCamera = (currentState?: CurrentState): currentState is CameraState => {
  return currentState?.deviceGpsType === DeviceGpsType.camera;
};

export function hasEnabledCameraFeatures(currentState?: CurrentState): boolean {
  if (!currentState) return false;
  const isRecent = moment(currentState.timestamp).isAfter(moment().subtract(30, 'minutes'));
  if (!isRecent) return false;
  const { sleepModeStatus, operationalState } = currentState;
  if (
    operationalState?.currentStatus &&
    [OperationalStateStatus.on, OperationalStateStatus.movement, OperationalStateStatus.inactive].includes(
      operationalState.currentStatus,
    )
  ) {
    return true;
  }
  return sleepModeStatus === false;
}
